import { pageTypes } from 'common/constants/pageTypes'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { CommonPage } from 'publisher/pages/common-page'

export const createPage = (type: keyof typeof pageTypes | PageTypeEnum) => {
  switch (type) {
    case PageTypeEnum.CustomLogin:
    case PageTypeEnum.SalesPage:
    case PageTypeEnum.OfferThankYouPage:
    case PageTypeEnum.OfferInnerThankYouPage:
      return CommonPage
    default:
      window.Rollbar?.error(`unknown page type ${type}`)
      return null
  }
}
